import { InjectionToken } from '@angular/core';
import { Environment } from '../../../environments/environment.interface';

export const WINDOW = new InjectionToken('window');
export const ENVIRONMENT = new InjectionToken<Environment>('Environment');